import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { TelephonyProvidersResponse } from './types';
import { getTelephonyProviders } from './api';

export function useGetTelephonyProviders(
  params?: any,
  options?: Omit<UseQueryOptions<TelephonyProvidersResponse, Error>, 'queryKey' | 'queryFn'>
) {
  return useQuery<TelephonyProvidersResponse>({
    queryKey: ['agency_providers_telephony_options', params],
    queryFn: () => getTelephonyProviders(params),
    ...options
  });
}
